module.exports = __webpack_public_path__ + "static/media/aljibesPercy.8029fd21.mp3";